// test920
(920 && 0);
